import { DISMISSAL_TYPE_LOCAL_STORAGE, TIMED_ELEMENT_STORAGE_KEY } from './TimedElement.constants';
import Storage from '../../../../services/storage';
export function getStorageMechanism(dismissalType) {
  if (dismissalType === DISMISSAL_TYPE_LOCAL_STORAGE) {
    return Storage.LOCAL_STORAGE;
  }
  return Storage.SESSION_STORAGE;
}
export function getTimedElementStorageKey(referenceId) {
  return "".concat(TIMED_ELEMENT_STORAGE_KEY, "_").concat(referenceId);
}